import { PictureOutlined } from '@ant-design/icons';
import type { ReactNode } from 'react';

/**
 * Logó-bélyegkép listákba és táblázatokba (#159).
 *
 * MIÉRT NEM `Avatar`. Az antd `Avatar` a képet `object-fit: cover`-rel tölti
 * ki, négyzetes dobozban. Egy avatarnál ez helyes — egy arcot középre vágni
 * rendben van —, egy logónál viszont adatvesztés: a Connect+Grow 52
 * szponzorának túlnyomó része FEKVŐ logó (pl. 800×159), és a `cover` a
 * négyzethez igazítva a két szélét levágta. Az admin Szponzorok listában a
 * szervező „LÓ CO"-t látott a Holló Company, „ERI"-t a Masterplast helyett,
 * vagyis a szponzort a logójáról nem ismerte fel.
 *
 * MIÉRT `contain` ÉS MIÉRT FEKVŐ DOBOZ. A `contain` a teljes logót mutatja,
 * oldalarányosan, semmit nem vág le. Négyzetes dobozban viszont egy fekvő logó
 * aprócskára zsugorodna (800×159 egy 48×48-as dobozban 48×9 px) — ezért az
 * alapértelmezés 2:1-es, a logók jellemző alakjához közelebb. Az álló és a
 * négyzetes logó ettől nem romlik: középen áll, két oldalt üres hellyel.
 *
 * A fehér háttér nem díszítés: az átlátszó PNG-k (a CMS-ből konvertált SVG-k
 * `-background none`-nal készültek) sötét sorháttéren eltűnnének.
 */
interface LogoThumbProps {
  src?: string | null;
  alt: string;
  /** A doboz szélessége px-ben. Alapértelmezés 96 — a logók többsége fekvő. */
  width?: number;
  /** A doboz magassága px-ben. Alapértelmezés 48. */
  height?: number;
  /** Logó nélkül ez jelenik meg. Alapértelmezés egy semleges kép-ikon. */
  fallback?: ReactNode;
}

export function LogoThumb({ src, alt, width = 96, height = 48, fallback }: LogoThumbProps) {
  return (
    <span
      data-testid="logo-thumb"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width,
        height,
        flexShrink: 0,
        overflow: 'hidden',
        borderRadius: 6,
        border: '1px solid #f0f0f0',
        background: '#fff',
      }}
    >
      {src ? (
        <img
          src={src}
          alt={alt}
          // A `padding` a dobozon BELÜL hagy levegőt, hogy a logó ne érjen a
          // keretig — de kicsi, mert minden képpont a logóé.
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            padding: 3,
            boxSizing: 'border-box',
          }}
        />
      ) : (
        (fallback ?? <PictureOutlined style={{ fontSize: height / 2, color: '#bfbfbf' }} />)
      )}
    </span>
  );
}

export default LogoThumb;
